import React, {useState} from "react"
import tinyArrow from "../../assets/svg/tinyArrow.svg"
import ArrowUp from "../../assets/svg/chevron-up.svg"
import ArrowDown from "../../assets/svg/chevron-down.svg"
/**
 * Table header component will render the table headings.
 */
export default function TableHeader({
  columns,
  setAscAndKey,
  sortDirection,
  sortKey,
  hoverState,
}) {
  const [isHover, setHover] = useState(false)
  const [hoverKey, setHoverKey] = useState()

  const handleMouseEnter = (hoverColumnKey) => {
    setHover(true)
    setHoverKey(hoverColumnKey)
    hoverState(isHover, hoverColumnKey)
  }

  const handleMouseLeave = (hoverColumnKey) => {
    setHover(false)
    setHoverKey("")
    hoverState(isHover, hoverColumnKey)
  }

  const columnHeaders = columns
    ? columns.map((col) => {
        return (
          <th
            key={col.key}
            align="left"
            width={`${col.width}%`}
            data-testid="th"
            className={
              "head-cell" +
              (isHover && hoverKey === col.key ? "-selected" : "") +
              " " +
              (col.headClass ? col.headClass : "")
            }
          >
            <div className="table-head-container">
              <div className="table-head-label">{col.name}</div>

              {col.sortable ? (
                <div
                  className="sort-icons-container"
                  onClick={() => setAscAndKey(col.key)}
                  onMouseEnter={() => handleMouseEnter(col.key)}
                  onMouseLeave={() => handleMouseLeave(col.selector)}
                >
                  {sortDirection && sortKey === col.key && (
                    <img
                      src={ArrowUp}
                      onClick={() => setAscAndKey(col.key)}
                      data-testid="sort-icon-up"
                      className="sort-icon"
                      alt="Sort icon"
                    />
                  )}
                  {!sortDirection && sortKey === col.key && (
                    <img
                      src={ArrowDown}
                      data-testid="sort-icon-down"
                      onClick={() => setAscAndKey(col.key)}
                      className="sort-icon"
                      alt="Sort icon"
                    />
                  )}
                  {!(sortKey === col.key) && (
                    <img
                      src={tinyArrow}
                      data-testid="sort-icon"
                      onClick={() => setAscAndKey(col.key)}
                      className="sort-icon"
                      alt="Sort icon"
                    />
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </th>
        )
      })
    : false

  return (
    <thead>
      <tr>{columnHeaders}</tr>
    </thead>
  )
}
